import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "checked", "value", "required", "aria-required"]
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!

  return (_openBlock(), _createBlock(_component_zeile, null, {
    default: _withCtx(() => [
      _createVNode(_component_titel_zelle, null, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Gebäudetyp")
        ])),
        _: 1,
        __: [1]
      }),
      _createVNode(_component_zelle, { class: "mkRadio" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gebaeudetypen, (option, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: option.label,
                name: "gebaeudetyp",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gebaeudetyp) = $event)),
                checked: option.value === _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp,
                value: option.value,
                required: _ctx.required,
                "aria-required": _ctx.required,
                autofocus: ""
              }, null, 8, _hoisted_1), [
                [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp]
              ]),
              _createElementVNode("label", {
                for: option.label,
                class: "radiolabel"
              }, _toDisplayString(option.label), 9, _hoisted_2)
            ], 64))
          }), 128)),
          _createVNode(_component_validierungs_fehler, {
            "fehler-text": _ctx.fehler.gebaeudetyp,
            "reduzierter-abstand": true
          }, null, 8, ["fehler-text"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}